import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = { stores: [] }, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            if (!types[action.waiting]) {
                return state;
            }

            return {
                ...state,
                loading: true,
                waiting: action.waiting,
                action: commonTypes.ASYNC_START,
            }
        }
        case commonTypes.ASYNC_END: {
            if (!types[action.done]) {
                return state;
            }

            return {
                ...state,
                waiting: null,
                loading: false,
                action: commonTypes.ASYNC_END,
            }
        }
        case types.ASSIGN_LIST: {
            return {
                ...state,
                action: types.ASSIGN_LIST,
                status: action.status,
                message: action.message,
                basicRule: action.status ? action.payload.basic_rule : [],
                advancedRules: action.status ? action.payload.advanced_rules : [],
                storeConfig: action.status ? action.payload.store_config : {},
            }
        }
        case types.ASSIGN_RELOAD: {
            return {
                ...state,
                action: types.ASSIGN_RELOAD,
                status: action.status,
                message: action.message,
                basicRule: action.status ? action.payload.basic_rule : [],
                advancedRules: action.status ? action.payload.advanced_rules : [],
                storeConfig: action.status ? action.payload.store_config : {},
            }
        }
        case types.ASSIGN_APPLY_BASIC: {
            return {
                ...state,
                action: types.ASSIGN_APPLY_BASIC,
                status: action.status,
                message: action.message,
            }
        }
        case types.ASSIGN_CREATE_ADVANCED: {
            return {
                ...state,
                action: types.ASSIGN_CREATE_ADVANCED,
                status: action.status,
                message: action.message,
            }
        }
        case types.ASSIGN_UPDATE_STORE_STATUS: {
            return {
                ...state,
                action: types.ASSIGN_UPDATE_STORE_STATUS,
                status: action.status,
                message: action.message,
            }
        }
        case types.ASSIGN_UPDATE_ONLINE_STATUS: {
            return {
                ...state,
                action: types.ASSIGN_UPDATE_ONLINE_STATUS,
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

